import { render, staticRenderFns } from "./QueryResultText.vue?vue&type=template&id=748c112f&scoped=true&"
import script from "./QueryResultText.vue?vue&type=script&lang=js&"
export * from "./QueryResultText.vue?vue&type=script&lang=js&"
import style0 from "./QueryResultText.vue?vue&type=style&index=0&id=748c112f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c112f",
  null
  
)

export default component.exports